import MenuIcon from './icons/menu-icon.svg';
import CartIcon from './icons/cart-icon.svg';
import SearchIcon from './icons/search-icon.svg';
import CloseIcon from './icons/close.svg';
import BackIcon from './icons/back-icon.svg';
import ChevronIcon from './icons/chevron-icon.svg';

import ViberLogo from './icons/social/viber.png';
import WhatsappLogo from './icons/social/whatsapp.png';
import SmsLogo from './icons/social/sms.png';
import CallLogo from './icons/social/call.png';

export const icons = {
  MenuIcon,
  CartIcon,
  SearchIcon,
  CloseIcon,
  BackIcon,
  ChevronIcon,
};

export const socialIcons = {
  ViberLogo,
  WhatsappLogo,
  SmsLogo,
  CallLogo,
};
